import 'bootstrap/dist/css/bootstrap.min.css';
import InProgress from "./Components/Construction/InProgress.js";

function Construction() {
  return (
    <InProgress />
  )
}

export default Construction;